import classNames from 'classnames';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import FlexContainer from '../FlexContainer';
import MapRender from '../MapRender';
import styles from './InputLocation.module.scss';

const getMapBounds = (map) => {
  const mapBounds = map.getBounds();
  return {
    lngMin: mapBounds.getWest(),
    lngMax: mapBounds.getEast(),
    latMin: mapBounds.getSouth(),
    latMax: mapBounds.getNorth(),
  };
};

/**
 * InputLocation
 *
 * @return {JSX.Element}
 */
const InputLocation = ({
  className,
  initialValue,
  name,
  onChange,
  children,
  whenCreated,
  ...rest
}) => {
  const [map, setMap] = useState(null);
  const initialValueLocal = useRef(initialValue);

  const handleMap = useCallback(
    (m) => {
      setMap(m);
      whenCreated?.(m);
    },
    [whenCreated]
  );

  const onMove = useCallback(() => {
    return onChange?.({
      target: {
        name,
        value: {
          ...map.getCenter(),
          bounds: getMapBounds(map),
        },
      },
    });
  }, [map, name, onChange]);

  useEffect(() => {
    if (map) {
      map.on('moveend', onMove);
      return () => map.off('moveend', onMove);
    }
  }, [map, onMove]);

  const displayMap = useMemo(
    () => (
      <MapRender
        whenCreated={handleMap}
        center={initialValueLocal.current}
        {...rest}
      >
        {children}
      </MapRender>
    ),
    [children, handleMap, rest]
  );

  return (
    <FlexContainer
      className={classNames(
        styles.InputLocation,
        className,
        `${InputLocation.displayName}`
      )}
      column
    >
      {displayMap ? displayMap : null}
    </FlexContainer>
  );
};

InputLocation.displayName = 'InputLocation';

export default InputLocation;
